import { delegate } from 'tippy.js'
$(document).ready(function() {
  delegate( '.admin-body', {
    target: '[data-tippy-content]',
    theme: 'light',
    popperOptions: {
      strategy: 'fixed'
    }
  });
})
